(function () {
  if (window.couponSavingsLoaded) return;
  window.couponSavingsLoaded = true;

  function updateSavings() {
    fetch('/cart.js?_=' + Date.now(), {
      cache: 'no-store'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {

        var savedBox = document.getElementById('coupon-saved');
        var messageBox = document.getElementById('coupon-message');

        if (!savedBox) return;

        var saved =
          Number(cart.original_total_price || 0) -
          Number(cart.total_price || 0);

        if (saved <= 0) {
          savedBox.style.display = 'none';
          return;
        }

        var currency = cart.currency || 'INR';

        var amount = new Intl.NumberFormat(
          document.documentElement.lang || 'en',
          {
            style: 'currency',
            currency: currency
          }
        ).format(saved / 100);

        savedBox.textContent =
          'You saved ' + amount + ' with this coupon!';

        savedBox.style.display = 'block';

        if (
          messageBox &&
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length
        ) {
          messageBox.style.color = '#16803c';

          messageBox.textContent =
            'Coupon applied: ' +
            cart.cart_level_discount_applications[0].title;
        }
      })
      .catch(function (error) {
        console.log('Coupon savings:', error);
      });
  }


  /* Apply coupon */
  document.addEventListener('click', function (event) {

    var button =
      event.target.closest('#apply-coupon-btn');

    if (!button) return;

    var input =
      document.getElementById('coupon-input');

    var message =
      document.getElementById('coupon-message');

    if (!input || !message) return;

    var code = input.value.trim();

    if (!code) {
      message.style.color = 'red';
      message.textContent =
        'Please enter a coupon code.';
      return;
    }

    message.style.color = '#555';
    message.textContent =
      'Applying coupon...';

    button.disabled = true;
    button.textContent = 'Applying...';

    window.location.href =
      '/discount/' +
      encodeURIComponent(code) +
      '?redirect=/cart';
  });


  /* Enter key */
  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Enter' &&
      event.target.id === 'coupon-input'
    ) {
      event.preventDefault();

      var button =
        document.getElementById('apply-coupon-btn');

      if (button) button.click();
    }
  });


  /*
   * Detect Dawn cart updates
   */
  var originalFetch = window.fetch;

  window.fetch = function () {

    var args = arguments;

    return originalFetch.apply(this, args)
      .then(function (response) {

        var url = '';

        if (typeof args[0] === 'string') {
          url = args[0];
        } else if (args[0] && args[0].url) {
          url = args[0].url;
        }

        if (
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/clear') !== -1
        ) {
          setTimeout(updateSavings, 500);
          setTimeout(updateSavings, 1000);
        }

        return response;
      });
  };


  /*
   * Dawn section re-render
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      setTimeout(updateSavings, 500);
    }
  );


  /*
   * Initial load
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateSavings
    );
  } else {
    updateSavings();
  }

})();